import { useState } from 'react'
import { Download, Monitor, Globe } from 'lucide-react'
import DownloadStatsTab from './DownloadStatsTab'
import TencentDownloadStatsTab from './TencentDownloadStatsTab'
import WebsiteDownloadStatsTab from './WebsiteDownloadStatsTab'

const SUB_TABS = [
  { id: 'baidu', label: '百度下载统计', icon: Download },
  { id: 'tencent', label: '腾讯下载统计', icon: Monitor },
  { id: 'website', label: '官网下载统计', icon: Globe }
]

export default function LandingDownloadStatsTab() {
  const [activeSubTab, setActiveSubTab] = useState('baidu')

  const renderContent = () => {
    switch (activeSubTab) {
      case 'tencent':
        return <TencentDownloadStatsTab />
      case 'website':
        return <WebsiteDownloadStatsTab />
      case 'baidu':
      default:
        return <DownloadStatsTab />
    }
  }

  return (
    <div className="space-y-6">
      <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm dark:border-gray-700 dark:bg-gray-800">
        <div className="flex flex-wrap gap-3">
          {SUB_TABS.map((tab) => {
            const Icon = tab.icon
            const isActive = activeSubTab === tab.id

            return (
              <button
                key={tab.id}
                onClick={() => setActiveSubTab(tab.id)}
                className={`inline-flex items-center gap-2 rounded-lg border px-4 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? 'border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-800 dark:bg-blue-900/30 dark:text-blue-400'
                    : 'border-gray-200 bg-gray-50 text-gray-600 hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-900/50 dark:text-gray-400 dark:hover:bg-gray-700'
                }`}
              >
                <Icon className="h-4 w-4" />
                {tab.label}
              </button>
            )
          })}
        </div>
      </div>

      {renderContent()}
    </div>
  )
}
